import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reactions-count"
}

import EmojiItem from "@/components/cards/EmojiItem/EmojiItem.vue";
import { getIsAutomaticMessageType } from "@/utils/message";
import { Message } from "@/store/chats/types";
import { computed, HTMLAttributes, ref } from "vue";
import { IconType } from "@/types/icons";
import MessageEmojiReactionsPanel from "../MessageEmojiReactionsPanel/MessageEmojiReactionsPanel.vue";
import DesktopReactionsControlsItem from "../DesktopReactionsControlsItem/DesktopReactionsControlsItem.vue";
import { GetterTypes } from "@/store";
import { useComputedValue, useGetMessageHandlers } from "@/composables";
import { LayoutTypes } from "@/store/app/state";
import { config } from "@/config";
import DesktopOtherActions from "../DesktopOtherActions/DesktopOtherActions.vue";

interface ChatMessageReactionsProps {
  message: Message;
  isMine: boolean;
  elementId: string;
}

interface Emits {
  (e: "openModal"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageWithReactions',
  props: {
    message: {},
    isMine: { type: Boolean },
    elementId: {}
  },
  emits: ["openModal"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const { handleReplyToMessage } = useGetMessageHandlers();

const props = __props;
const isDesktopControlsVisible = ref(false);
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const isMobile = computed(() => layoutType.value === LayoutTypes.MOBILE);
const isMessageAutomatic = computed(() =>
  getIsAutomaticMessageType(props.message),
);
const isActionsOpen = ref(false);
const transformStyle = ref("");
const styleObj = computed<HTMLAttributes["style"]>(() => ({
  transform: transformStyle.value,
}));
const currentIcon = ref<IconType | null>(null);
const isReactingEnabled = computed(
  () => !getIsAutomaticMessageType(props.message) && !props.message.isDeleted,
);

const showActions = () => {
  isActionsOpen.value = true;
};
const closeActions = () => {
  isActionsOpen.value = false;
};

const isPanelVisible = computed(() => {
  const isVisible =
    isReactingEnabled.value &&
    (isDesktopControlsVisible.value || isActionsOpen.value);

  return isVisible;
});

const openReactionsModal = () => {
  emit("openModal");
};

const toggleDesktopControls = (newValue: boolean) => {
  if (isMobile.value || !isReactingEnabled.value) {
    return;
  }
  isDesktopControlsVisible.value = newValue;
};

const showDesktopControls = () => {
  toggleDesktopControls(true);
};
const hideDesktopControls = () => {
  toggleDesktopControls(false);
  currentIcon.value = null;
};

const getTransformStyle = (width: number) => {
  let addition: number = width + 16;
  if (props.isMine) {
    addition = -addition;
  }

  return `translateX(calc(-50% + ${addition}px))`;
};

const toggleActiveIcon = (icon: IconType) => {
  currentIcon.value = icon;
};

const safeTransformReactionsPanel = () => {
  const contentEl = document.getElementById(props.elementId);
  if (!contentEl) {
    return;
  }
  const { width } = contentEl.getBoundingClientRect();
  // if the width of reactions panel does not overflow the chat wrapper, do nothing
  if (width >= config.constants.REACTIONS_SAFE_WIDTH) {
    return;
  }
  transformStyle.value = getTransformStyle(width);
};

const replyToMessage = () => {
  handleReplyToMessage(props.message);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "message-with-reactions",
      onMouseenter: showDesktopControls,
      onMouseleave: hideDesktopControls
    }, [
      (!isMobile.value && !isMessageAutomatic.value)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "pop"
          }, {
            default: _withCtx(() => [
              (isPanelVisible.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["desktop-reactions-panel", { isMine: _ctx.isMine }])
                  }, [
                    _createVNode(DesktopReactionsControlsItem, {
                      "active-icon": _unref(IconType).EMOJI_BLACK,
                      "inactive-icon": _unref(IconType).EMOJI_GRAY,
                      "current-icon": currentIcon.value,
                      onOnActiveIconChange: safeTransformReactionsPanel,
                      onToggleActiveIcon: toggleActiveIcon
                    }, {
                      default: _withCtx(() => [
                        (currentIcon.value === _unref(IconType).EMOJI_BLACK)
                          ? (_openBlock(), _createBlock(MessageEmojiReactionsPanel, {
                              key: 0,
                              style: _normalizeStyle(styleObj.value),
                              "message-id": _ctx.message.id,
                              "is-mine": _ctx.isMine,
                              onClosePanel: hideDesktopControls
                            }, null, 8, ["style", "message-id", "is-mine"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["active-icon", "inactive-icon", "current-icon"]),
                    _createVNode(DesktopReactionsControlsItem, {
                      "active-icon": _unref(IconType).REPLY,
                      "inactive-icon": _unref(IconType).REPLY_GRAY,
                      "current-icon": currentIcon.value,
                      onToggleActiveIcon: toggleActiveIcon,
                      onClick: replyToMessage
                    }, null, 8, ["active-icon", "inactive-icon", "current-icon"]),
                    _createVNode(DesktopReactionsControlsItem, {
                      "active-icon": _unref(IconType).DOTS_BLACK,
                      "inactive-icon": _unref(IconType).DOTS,
                      "current-icon": currentIcon.value,
                      onToggleActiveIcon: toggleActiveIcon,
                      onClick: showActions
                    }, {
                      default: _withCtx(() => [
                        (isActionsOpen.value)
                          ? (_openBlock(), _createBlock(DesktopOtherActions, {
                              key: 0,
                              "is-mine": _ctx.isMine,
                              message: _ctx.message,
                              onCloseActions: closeActions
                            }, null, 8, ["is-mine", "message"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["active-icon", "inactive-icon", "current-icon"])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 32),
    (
      !_unref(getIsAutomaticMessageType)(_ctx.message) &&
      _ctx.message.reactions?.visibleItems?.length
    )
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["current-emoji-reactions", { isMine: _ctx.isMine }]),
          onClick: openReactionsModal
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.reactions.visibleItems, (emoji, ind) => {
            return (_openBlock(), _createBlock(EmojiItem, {
              key: ind,
              size: isMobile.value ? 12 : 20,
              emoji: emoji
            }, null, 8, ["size", "emoji"]))
          }), 128)),
          (_ctx.message.reactions.isCountVisible)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.message.reactions.count), 1))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})